/* CWV Wave 1B fix (QA blocker 2): a third-party app bundle later overwrites window.jQuery
   with a plugin-less 3.7.1, so window.onload-time inits that grab window.jQuery lose slick.
   This file is DEFERRED and placed immediately after theme.min.js in layout/theme.liquid,
   so it executes right after slick is registered (deferred scripts run in document order)
   and long before late-loading app bundles overwrite the global. Inits must prefer
   window.__gzJQ over window.jQuery. Only captures an instance that actually owns slick. */
(function () {
  var jq = window.jQuery;
  if (jq && jq.fn && jq.fn.slick) {
    window.__gzJQ = jq;
  }
})();
